document.addEventListener("turbolinks:load", () => {  // iwan

  $modal = $('#sideModal');

  $modal.on('shown.bs.modal', function() {
    if (focus_on = $modal.data('focus_on')) {
      $("<%= focus_on %>").focus();
    }
    // console.log("%%%%");
    // showEventMap();
  });

  $modal.on('hidden.bs.modal', function() {
    $modal.data('focus_on', null)
    // disposeEventMap();
  });

})
